/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { checkRol } from '../security';
import { aprobador } from '../security/constantsRols';
import {
  getImputationType,
  getBusinessUnits,
  getAllBusinessUnits,
  getEvents,
  getOperationsOyM,
  typeUbicationSS,
  getAllOperations
} from '../services/yclickMaster';
import { useFilterContext } from '../context/FilterContext';
import { ubicationTypeEnum } from '../utils/dataStatus';
import { getPriorities, statusSS } from '../services/serviceRequest';

import useToast from './useToast';

const useLoadServices = (
  { createSDS = false, ignoreInitLoad = false } = {
    ignoreInitLoad: false
  }
) => {
  const [businessUnitSelect, setBusinessUnitSelect] = useState([]);
  const [operationsSelect, setOperationsSelect] = useState([]);
  const [eventTypeSelect, setEventTypeSelect] = useState([]);
  const [imputationTypeSelect, setImputationTypeSelect] = useState([]);
  const [statusSelect, setStatusSelect] = useState([]);
  const eventsSelect = [];
  const [ubicationTypeSelect, setUbicationTypeSelect] = useState([]);
  const [prioritySelect, setPrioritySelect] = useState([]);
  const { setNewToast } = useToast();
  const filterContext = useFilterContext();
  const formikFilters = filterContext?.formikFilters;
  const values = formikFilters?.values;

  const location = useLocation();
  const approverRoute = location.pathname === '/approver';

  const isApprover = checkRol(aprobador) && approverRoute;

  const tipoUbicacionId = values?.tipoUbicacionEnum?.id;
  const isOyM =
    !!tipoUbicacionId &&
    ![ubicationTypeEnum.pozo, ubicationTypeEnum.locacion].includes(tipoUbicacionId);

  const getDataSelects = async () => {
    try {
      if (isApprover) {
        if (!ignoreInitLoad) {
          const businessUnitResult = await getAllBusinessUnits();

          setBusinessUnitSelect(businessUnitResult);
        }
      } else {
        const statusResult = await statusSS();

        setStatusSelect(statusResult);

        const businessUnitResult = await getBusinessUnits();

        setBusinessUnitSelect(businessUnitResult);

        const operationsResult = await getAllOperations();

        setOperationsSelect(operationsResult);

        const priorities = await getPriorities();

        setPrioritySelect(priorities);
      }
      const eventTypeResult = await getEvents();

      setEventTypeSelect(eventTypeResult);

      const ubicationTypeResult = await typeUbicationSS(!!createSDS);

      setUbicationTypeSelect(ubicationTypeResult);

      const imputationTypeResult = await getImputationType();

      setImputationTypeSelect(imputationTypeResult);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  useEffect(() => {
    getDataSelects();
  }, []);

  useEffect(() => {
    if (!values?.tipoUbicacionEnum?.id) {
      return;
    }
    if (isOyM) {
      getOperationsOyM({
        tipoUbicacionId: values?.tipoUbicacionEnum?.id
      })
        .then(setBusinessUnitSelect)
        .catch((err) =>
          setNewToast({
            type: 'ERROR',
            message: err.message
          })
        );
    } else {
      getBusinessUnits()
        .then(setBusinessUnitSelect)
        .catch((err) =>
          setNewToast({
            type: 'ERROR',
            message: err.message
          })
        );
    }
  }, [isOyM, values?.tipoUbicacionEnum?.id]);

  return {
    businessUnitSelect,
    operationsSelect,
    eventTypeSelect,
    imputationTypeSelect,
    statusSelect,
    eventsSelect,
    ubicationTypeSelect,
    prioritySelect
  };
};

export default useLoadServices;
